module.exports = __webpack_public_path__ + "img/e_card.d67b16c7.png";